import { render, staticRenderFns } from "./SellerOrderList.vue?vue&type=template&id=3f3d631f&"
import script from "./SellerOrderList.vue?vue&type=script&lang=js&"
export * from "./SellerOrderList.vue?vue&type=script&lang=js&"
import style0 from "./SellerOrderList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports